import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

import { UserService, Utils } from '@app/services';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'authImg'
})
export class AuthImgPipe implements PipeTransform {
  constructor(private http: HttpClient, private domSan: DomSanitizer, private userServ: UserService, private utils: Utils) { }

  transform(src: string, type?: string) {
    const loader = new BehaviorSubject(this.domSan.bypassSecurityTrustUrl('assets/load-img.jpg'));

    if (this.userServ.cacheImg[type]) {
      loader.next(this.userServ.cacheImg[type]);
    } else {
      const token = sessionStorage.getItem('JWT_TOKEN');
      const headers = new HttpHeaders({ 'authorization': token });

      this.http.get(`${environment.apiUrlBase}${src}`, { headers, responseType: 'arraybuffer' }).subscribe(buffer => {
        const blob = new Blob([new Uint8Array(buffer)]);
        this.userServ.cacheImg[type] = this.domSan.bypassSecurityTrustUrl(URL.createObjectURL(blob));
        loader.next(this.userServ.cacheImg[type]);
      });
    }

    return loader;
  }

}
